import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { getCurrencyAmount } from "./../../../utils/stringUtils";
import { paymentConfirmationServices as services } from "../../../services/paymentConfirmationServices";

import Pagination from "./../../../components/common/Pagination";
import Table from "./../../../components/common/Table";
import Toaster from "./../../../components/common/Toaster";

import moment from "moment";

const PaymentConfirmationTable = ({
  data,
  columns,
  options,
  onChange,
  setData,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await services.getPaymentConfirmationAsync(options);
        const { result, page, total_count } = response;
        const items = result.map((item) => {
          const url = `/accounts/billing/${item.account_id}`;

          item["amount_value"] = item.amount;
          item["transaction_date"] = item.payment_date;
          item["amount"] = getCurrencyAmount(item.amount);
          item["invoice_amount"] = getCurrencyAmount(item.invoice_amount);
          item["payment_date"] = moment(item.payment_date).format("LL");
          item["created_on"] = moment(item.created_on).format("LL");
          item["name"] = (
            <Link className="hover:text-blue-400" to={url}>
              {item.name}
            </Link>
          );

          return item;
        });

        if (mounted) {
          setData(items);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        setIsLoading(false);
        Toaster.Error("Something went wrong.");
      }
    },
    [options, setData]
  );

  const handleSort = (sort_column) => {
    const new_options = { ...options };
    new_options.sort_column = sort_column;
    onChange(new_options);
  };

  const handlePageChange = (page) => {
    const new_options = { ...options };
    new_options.current_page = page;
    onChange(new_options);
  };

  useEffect(() => {
    let mounted = true;

    fetchData(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchData]);

  return (
    <div className="mt-10 overflow-auto lg:overflow-visible">
      <Table
        data={data}
        columns={columns}
        sortColumn={options.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={options.size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default PaymentConfirmationTable;
